const getSavedCalculatorData = require("../../run/roiCalculator/getSavedCalculatorData");
const triggerGoogleAnalyticsEventForRoiCalculatorFormFields = require("../../run/roiCalculator/triggerGoogleAnalyticsEventForRoiCalculatorFormFields");
const saveCalculatorData = require("../../run/roiCalculator/saveCalculatorData");

/**
 * @param calculatorData {RoiCalculatorFormData}
 * @return {void}
 */
module.exports = function whenRoiCalculatorFormUpdatedEvent(calculatorData) {
    const savedCalculatorData = getSavedCalculatorData();

    if (savedCalculatorData) {
        triggerGoogleAnalyticsEventForRoiCalculatorFormFields(savedCalculatorData, calculatorData);
    }

    saveCalculatorData(calculatorData);
}
